module.exports = __webpack_public_path__ + "img/01_uk.a5b2da66.svg";